import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { merchantActionTypes } from '../action-types';
import * as React from 'react';
import { IAction, IWorkflows, IWorkflowsData } from '../merchant-interfaces';
import { GET, POST } from '../../store-helper';

export const fetchWorkflow = async (dispatch: React.Dispatch<IAction>, mid: string = ''): Promise<void> => {
    try {
        dispatch({ type: merchantActionTypes.SET_WORKFLOWS_LOADING, payload: true });
        const actualWorkflowId = await GET({ pathname: `${BASE_URL.ELIGIBILITY}/EligibilityWorkflows/${mid}/actual-workflow-id` });

        if (actualWorkflowId) {
            const workflowVersionId = await GET({ pathname: `${BASE_URL.WORKFLOW_ENGIN}/Workflows/${actualWorkflowId}/get-actual-workflow-version-id` });

            if (workflowVersionId) {
                const externalControls = await GET({ pathname: `${BASE_URL.WORKFLOW_ENGIN}/Workflows/${workflowVersionId}/external-controls` });

                const ids = (externalControls ?? []).map((item: any) => item.id);

                const externalControlsAdditional = await POST({
                    pathname: `${BASE_URL.ELIGIBILITY}/EligibilityWorkflows/${mid}/get-external-controls`,
                    body: { externalControlIds: ids }
                });

                const externalControlsData: IWorkflowsData[] = (externalControls ?? []).map((item: any) => {
                    const additional = externalControlsAdditional?.externalControlValues?.find((i: any) => i.externalControlId === item.id);

                    // console.log('additional?.value',
                    //     additional?.value,
                    //     item?.defaultValue,
                    //     typeof additional?.value !== undefined,
                    //     typeof additional?.value,
                    //     typeof additional?.value !== undefined ? additional?.value === 'true' : item?.defaultValue === 'true');

                    // let value: boolean | number = typeof additional?.value !== 'undefined' ? additional?.value === 'true' : item?.defaultValue === 'true';
                    let value: boolean | number;

                        if (typeof additional?.value !== 'undefined') {
                            value = additional?.value === 'true';
                        }

                    if (item.type === 'IntegerValue' && typeof additional?.value !== 'undefined') {
                        const existingValue = isNaN(Number(additional?.value)) ? null : Number(additional?.value);
                        const defaultValue = isNaN(Number(item?.defaultValue)) ? 0 : Number(item?.defaultValue);

                        if (existingValue != undefined && existingValue !== null) {
                            value = existingValue;
                        }
                    }

                    return {
                        ...item,
                        ...additional,
                        value,
                    };
                });

                const data: IWorkflows = {};
                externalControlsData?.forEach((item: any) => {
                    if (data[item.group]) {
                        if (data[item.group][item.subGroup]) {
                            data[item.group][item.subGroup].push(item);
                        } else {
                            data[item.group][item.subGroup] = [item];
                        }
                    } else {
                        data[item.group] = { [item.subGroup]: [item] };
                    }
                });

                dispatch({ type: merchantActionTypes.FETCH_WORKFLOWS, payload: {
                        workflowsData: externalControlsData,
                        workflows: data,
                    }});
                // console.log('fetchWorkflow', externalControlsData, data);
            }
        }
    } catch (e) {
        // Sentry.setTag('fetch-widget-config-siteId', siteId);
        // Sentry.setTag('fetch-widget-config-mid', mid);
        // sendSentryMessage({ name: `GET Fetch widget configuration error`, context: e });
        dispatch({ type: merchantActionTypes.SET_WORKFLOWS_LOADING, payload: false });
    }
};

export const updateWorkflow = async (mid: string = '', data: { [key: string] : boolean }): Promise<void> => {
    try {
        const values = [];

        Object.keys(data || {})?.forEach((key) => {
            const value = {
                externalControlId: key,
                value: data[key],
            };

            values.push(value);
        });

        await axios.put(`${BASE_URL.ELIGIBILITY}/EligibilityWorkflows/${mid}/external-controls`, {
            values,
        });
        // eslint-disable-next-line no-empty
    } catch {}
};
